export const generateFontFamily = (name: string) => {
  return `${name}, "${name} Fallback: Arial", "${name} Fallback: Times New Roman", "${name} Fallback: Roboto", sans-serif`;
};
